import { render } from "./homeEvaStat.vue?vue&type=template&id=4b2c5e90&scoped=true"
import script from "./homeEvaStat.vue?vue&type=script&lang=js"
export * from "./homeEvaStat.vue?vue&type=script&lang=js"

import "./homeEvaStat.vue?vue&type=style&index=0&id=4b2c5e90&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2c5e90"]])

export default __exports__